<template>
  <div class="uk-margin">
    <label class="uk-form-label uk-display-block">
      {{ label }}
    </label>

    <div class="kmc-field-help-text" v-if="helpText">
      {{ helpText }}
    </div>

    <div class="uk-form-controls uk-position-relative">


<div class="kmc-select">
  <input ref="input"
         class="kmc-input"
         :name="name"
         :aria-label="label"
         @input="handleInput"
         @blur="handleBlur"
         @focus="displayResults"
         @click="displayResults"
  />

  <div class="arrow"></div>

  <div class="kmc-input-autocomplete-results" v-if="shouldShowResults">
    <div
        v-for="item in filteredResults"
        :key="item"
        @click="clickItem(item)"
        @mousedown.prevent
    >{{ displayItem(item) }}
    </div>
    <div v-if="!filteredResults || !filteredResults.length">
      No matches found
    </div>
  </div>
</div>

    </div>

    <div class="kmc-field-error-text">
      {{ errorMessage }}
    </div>

  </div>
</template>

<script>
import {computed, onMounted, ref, watch} from 'vue';
import {useField} from "vee-validate";

export default {
  name: "KmcInputAutocomplete",
  props: {
    helpText: {
      type: String,
    },
    value: {
      type: Object,
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    options: {
      type: Array,
    }
  },
  setup: function (props, context) {

    const input = ref(null)

    const {
      value: inputValue,
      errorMessage,
      meta,
      handleBlur: handleBlur_,
      handleChange,
    } = useField(props.name, undefined, {
      initialValue: props.value,
    });

    watch(errorMessage, (current, previous) => {
      input.value.setCustomValidity(current || '');
    })

    let showResults = ref(false)
    let timeout = null
    let filteredResults = ref([])

    let shouldShowResults = computed(() => {
      return showResults.value
    })

    onMounted(() => {
      handleInput(null)
    })

    function handleInput(e) {

      clearTimeout(timeout)
      timeout = setTimeout(() => {
        const val = input.value.value.toLowerCase().trim()

        if (val !== '') {
          filteredResults.value = props.options.filter(o => {
            return o['Title'].toLowerCase().indexOf(val) !== -1
          });
        } else {
          filteredResults.value = props.options
        }

        if (e) {
          handleChange(null)
        }
      }, 100)
    }

    const clickItem = function (data) {
      showResults.value = false
      input.value.value = data['Title']
      handleChange(data)
    }

    function displayResults() {
      if (!filteredResults.value) {
        filteredResults.value = props.options
      }
      showResults.value = true
    }

    function hideResults() {
      showResults.value = false
    }

    const handleBlur = function (e) {
      hideResults()
      handleBlur_(e)
    }

    const displayItem = function (item) {
      return item['label']
    }

    return {
      input,
      errorMessage,
      inputValue,
      meta,
      handleBlur,
      handleChange,
      shouldShowResults,
      displayResults,
      filteredResults,
      clickItem,
      displayItem,
      handleInput

    };
  }
}

</script>

